import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import Pagination from '../../model/pagination';
import UserModel from '../../model/user.model';
import {environment} from '../../environments/environment';
import QueryEncoder from '../queryEncoder';
import NoteModel from '../../model/note.model';
import {catchError, switchMap} from 'rxjs/operators';
import CooperationTaskModel from '../../model/cooperationTask.model';

@Injectable()
export default class TaskService {
  public constructor(private http: HttpClient) {
  }

  public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string, additionalInfo?: any): Observable<Pagination<CooperationTaskModel>> {
    query = query || '';
    page = page || 1;
    limit = limit || 15;
    sort = sort || '';

    let sorting = {};
    sorting[sort] = direction;

    let q = {query, page, limit, sorting};

    if(additionalInfo) {
      Object.assign(q, additionalInfo);
    }

    return this.http
      .get<Pagination<CooperationTaskModel>>(environment.apiUrl + '/tasks?' + QueryEncoder.encodeURI(q));
  }

  public create(task: CooperationTaskModel): Observable<CooperationTaskModel> {
    return this.http
      .post<CooperationTaskModel>(environment.apiUrl + '/tasks', task);
  }

  public update(task: CooperationTaskModel): Observable<boolean> {
    return this.http.put(environment.apiUrl + '/tasks/' + task.id, task).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }

  public delete(task: CooperationTaskModel): Observable<boolean> {
    return this.http.delete(environment.apiUrl + '/tasks/' + task.id).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }

  public done(task: CooperationTaskModel): Observable<boolean> {
    return this.http.post(environment.apiUrl + '/tasks/' + task.id + '/done', {}).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }

  public undone(task: CooperationTaskModel): Observable<boolean> {
    return this.http.post(environment.apiUrl + '/tasks/' + task.id + '/undone', {}).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }
}
